<template>
    <main class="page-404 app__main">
        <layout-title-bar>
            <slot name="title-bar"></slot>
        </layout-title-bar>

        <div class="page-404__container">
            <h2 class="page-404__title">
                Erreur 404
            </h2>
            <p class="page-404__text">
                Cette page n’est plus disponible et nous nous en excusons. Nous vous invitons à cliquer ci dessous
            </p>

            <a :href="buttonUrl" class="page-404__button rounded-button rounded-button--white">
                Toutes les actus et publications
            </a>
        </div>
    </main>
</template>

<script>
    import LayoutTitleBar from '@/components/layout/TitleBar';
    import RoundedButton from '@/components/RoundedButton';

    export default {
        name: 'NotFound',

        components: { LayoutTitleBar, RoundedButton },

        props: {
            buttonUrl: { type: String, default: null },
        },
    };
</script>

<style lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .page-404 {
        display:        flex;
        flex-direction: column;

        &__container {
            display:         flex;
            flex-direction:  column;
            justify-content: center;
            align-items:     center;

            flex:            1 0 auto;

            padding:         5rem 2rem;

            background:      url('~@/assets/images/background-not-found.jpg') no-repeat top center;
            background-size: cover;
            color:           white;
        }

        &__title {
            @extend %font-DINPro-Light;
            font-size: 2.6rem;

            @include media-breakpoint-up(sm) {
                font-weight: 400;
                font-size:   5rem;
            }
        }

        &__text {
            max-width:  40rem;
            text-align: center;

            @extend %font-DINPro-Regular;
            font-size:  1.4rem;

            @include media-breakpoint-up(sm) {
                font-size: 1.6rem;
            }

        }

        &__button {
            margin-top: 3rem;
        }
    }
</style>
